var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserSpeakOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.652 11.966.806.87c2.001-2.163 2.001-5.672 0-7.836l-.806.87c.748.809 1.168 1.905 1.168 3.048s-.42 2.24-1.168 3.048zm-1.611-1.742.805.871c1.112-1.203 1.112-3.152 0-4.354l-.805.872c.666.721.666 1.89 0 2.61zm-8.673-.919c0-1.978 1.648-3.57 3.666-3.57S8.7 7.327 8.7 9.305c0 1.979-1.648 3.57-3.666 3.57s-3.666-1.591-3.666-3.57zm13.932 0c0-1.978 1.648-3.57 3.666-3.57s3.666 1.592 3.666 3.57c0 1.979-1.648 3.57-3.666 3.57S15.3 11.285 15.3 9.306zM0 18.932c0-2.713 2.26-4.901 5.034-4.901s5.034 2.187 5.034 4.9v.246H0v-.245zm13.932 0c0-2.713 2.26-4.901 5.034-4.901S24 16.218 24 18.93v.246H13.932v-.245z",
    fill: "#FF9300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSpeakOrange);
export default __webpack_public_path__ + "static/media/user_speak_orange.7d35764ca829eb99f8ca67603bd276c6.svg";
export { ForwardRef as ReactComponent };